import styles from './Blocker.module.scss';
import { ROUTES } from '../../../../routes/constants';
import useWindowSize from '../../../../utils/useWindowSize';
import clx from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Blocker = () => {
    const { t } = useTranslation();
    const { isMobile } = useWindowSize();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`${ROUTES.SALON_MANAGEMENT}${ROUTES.SERVICES}`);
    };

  return (
    <div className={clx(styles.blocker_container, { [styles['blocker_container_mobile']]: isMobile })}>
        <section className={clx(styles.container, { [styles.container_mbl]: isMobile} )}>
            <summary className={styles.header}>
                <span className={styles.h1}>{t('scheduler.blocker.title')}</span>
                <p className={styles.description} >{t('scheduler.blocker.description1')}</p>
                <p className={styles.description} style={{fontWeight: '600'}}>{t('scheduler.blocker.description2')}</p>
            </summary>
            <Button onClick={handleClick} className={styles.confirm_button}>
                {t('scheduler.blocker.action')}
            </Button>
            </section>
    </div>
  );
};

export default Blocker;
